import { GenericObject } from '../lib/models';

export const palette = {
  red: '#E60012',
  lightGrey: '#F5F5F5',
  grey: '#E8E7E7',
  black: '#000',
  white: '#FFF',
};

export const breakpoints = {
  xs: 320,
  mobile: 375,
  tablet: 768,
  desktop: 980,
  xl: 1920,
};

// Breakpoints
export const media = {
  xs: `@media (min-width: ${breakpoints.xs}px)`,
  mobile: `@media (min-width: ${breakpoints.mobile}px)`,
  tablet: `@media (min-width: ${breakpoints.tablet}px)`,
  desktop: `@media (min-width: ${breakpoints.desktop}px)`,
  xl: `@media (min-width: ${breakpoints.xl}px)`,
  notDesktop: `@media (max-width: ${breakpoints.desktop - 1}px)`,
  landscapeTablet: `@media (device-width: 768px) and (device-height: 1024px) and (orientation:landscape)`,
};

export const appMaxWidth = '980px';

export const rootFontSize = '16px';

// Functions
export const normalizeStyles = (styles: GenericObject) => {
  if (!styles) {
    return null;
  }

  return Object.keys(styles).reduce((storage, target) => {
    const store = Object.keys(styles[target]).reduce((store, property) => {
      if (!store[target]) {
        store[target] = {};
      }
      const normalizedProperty = property.replace(/_([a-z])/g, (text) => text[1].toUpperCase());

      const a11yStyle =
        normalizedProperty === 'fontSize' ? pxToRem(styles[target][property]) : styles[target][property];

      store[target][normalizedProperty] = a11yStyle;

      return store;
    }, Object.create(null));
    return { ...storage, ...store };
  }, Object.create(null));
};

export const children = (child: string) => {
  return `:nth-child(1n) ${child}`;
};

/* tslint:disable:no-bitwise */
export const darkenColor = (color: string) => {
  let hex = '';

  switch (color) {
    case undefined:
    case null:
    case '#000':
    case '#000000':
      break;
    case '#fff':
    case '#ffffff':
      hex = '#ccc';
      break;
    default:
      const percent = -0.2; // This can be passed as a parameter
      const f = parseInt(color.slice(1), 16);
      const t = percent < 0 ? 0 : 255;
      const p = percent < 0 ? percent * -1 : percent;
      const R = f >> 16;
      const G = (f >> 8) & 0x00ff;
      const B = f & 0x0000ff;
      hex =
        '#' +
        (
          0x1000000 +
          (Math.round((t - R) * p) + R) * 0x10000 +
          (Math.round((t - G) * p) + G) * 0x100 +
          (Math.round((t - B) * p) + B)
        )
          .toString(16)
          .slice(1);
      break;
  }

  return hex;
};
/* tslint:enable:no-bitwise */

export const pxToRem = (fontSize: string) => {
  return `${parseInt(fontSize, 10) / parseInt(rootFontSize, 10)}rem`;
};

export const applyAspectRatio = (aspectRatio = 16 / 9) => {
  const ratio = +(1 / aspectRatio).toFixed(4) * 100;
  const paddingBottom = ratio + '%';
  return { paddingBottom };
};
